import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import '../styles.less'
import FillingListReportWidget from '../../../widgets/eFillingListFormWidgets/FillingListReportWidget'
import { getEfillingReport } from '../../../redux/actions/eFilling'

export default function eFillingListReport() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionStorage.getItem('projectCode')
  const pageNumber = 0
  const pageSize = 0

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getEfillingReport({projectCode : projectCode}, pageNumber, pageSize)
      setSchema(response.model)
      // console.log('response==>', response)
      // setSchema(mockSchema.model)
      // console.log('mockSchema==>', schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <FillingListReportWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}
const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    header: 'รายงานการยื่นแบบและชำระภาษีออนไลน์ (e-Filing)',
    subHeader: '',
    disabled: false,
    forms: {
      header: 'เพิ่มข้อมูลยื่น eFilling',
      modelType: {
        name: 'modelType',
        label: 'ประเภทแบบ',
        value: '',
        options: [
          {
            disabled: false,
            label: 'ภ.ง.ด.1',
            value: '1',
          },
          {
            disabled: false,
            label: 'ภ.ง.ด.3',
            value: '2',
          },
          {
            disabled: false,
            label: 'ภ.ง.ด.53',
            value: '3',
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณาเลือกรายการ',
          },
        ],
      },
      projectCode: {
        name: 'projectCode',
        label: 'รหัสโครงการ  ',
        value: '66-00018',
        disabled: false,
      },
      contractNo: {
        name: 'contractNo',
        label: 'เลขที่ข้อตกลง ',
        value: '66-P1-0011',
        disabled: false,
      },
      submisList: {
        name: 'submisList',
        label: 'ลำดับการยื่นแบบ',
        value: null,
        disabled: false,
      },
      submisList: {
        name: 'submisList',
        label: 'ลำดับการยื่นแบบ',
        value: null,
        disabled: false,
      },

      ReferenceNo: {
        name: 'ReferenceNo',
        label: 'หมายเลขอ้างอิงรอชำระเงิน/หมายเลขอ้างอิงการยื่นแบบ',
        value: null,
        disabled: false,
      },
      submisStatus: {
        name: 'submisStatus',
        label: 'สถานะยื่นแบบ',
        value: '',
        options: [
          {
            disabled: false,
            label: 'อยู่ระหว่างยื่นแบบ',
            value: '1',
          },
          {
            disabled: false,
            label: 'ยื่นแบบสำเร็จ',
            value: '2',
          },
          {
            disabled: false,
            label: 'ยื่นแบบสำเร็จ (รอออกใบเสร็จรับเงิน)',
            value: '3',
          },
          {
            disabled: false,
            label: 'ยื่นแบบสำเร็จ (ออกใบเสร็จรับเงินแล้ว)',
            value: '4',
          },
          {
            disabled: false,
            label: 'รอชำระเงิน (หากชำระแล้วรอ 2 วัน)',
            value: '5',
          },
          {
            disabled: false,
            label: 'ชำระภาษีสำเร็จ (รอออกใบเสร็จรับเงิน)',
            value: '6',
          },
          {
            disabled: false,
            label: 'เกินกำหนดเวลา (ชำระเงิน)',
            value: '7',
          },
          {
            disabled: false,
            label: 'ยกเลิกแบบโดยผู้ใช้',
            value: '8',
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณาเลือกรายการ',
          },
        ],
      },
      TransactionDate: {
        name: 'TransactionDate',
        label: 'วันที่ทำรายการ',
        value: null,
        disabled: false,
      },
      DateEdited: {
        name: 'DateEdited',
        label: 'วันที่แก้ไขรายการล่าสุด',
        value: null,
        disabled: false,
      },
      attachFiles: {
        name: 'attachFiles',
        label: 'เอกสารแนบประกอบ',
        value: [],
      },
      submisDate: {
        name: 'submisDate',
        label: 'วันที่ยื่นแบบ',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกวันที่ยื่นแบบ',
          },
        ],
      },
      taxMonth: {
        name: 'taxMonth',
        label: 'เดือนที่ยื่นภาษี',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกรายการ',
          },
        ],
      },
      submitStartDate: {
        name: 'submitStartDate',
        label: 'วันที่ยื่นแบบเริ่มต้น',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกวันที่ยื่นแบบเริ่มต้น',
          },
        ],
      },
      submiyEndDate: {
        name: 'submiyEndDate',
        label: 'วันที่ยื่นแบบสิ้นสุด',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกวันที่ยื่นแบบสิ้นสุด',
          },
        ],
      },
    },
    eFillingListValues: [
      {
        id: '9F262C5E-6870-122E-ADBA-172E3DC1903A',
        projectCode: '66-00019',
        contractNo: '66-P1-0012',
        submisDate: '07/ก.พ./2567',
        modelType: '1',
        modelTypeLabel: 'ภ.ง.ด.1',
        taxMonth: 'พ.ย./2566',
        submisList: 'ยื่นเพิ่มเติม ครั้งที่ 001',
        ReferenceNo: 'P01XXXXXXXXXX',
        submisStatus: 'ยื่นแบบสำเร็จ (ออกใบเสร็จรับเงินแล้ว)',
        receiptDate: '07/ก.พ./2567',
        submitName: 'นายโบวา เยล',
        phoneNumber: '0993845129',
        TransactionDate: '10 พฤษภาคม 2024',
        DateEdited: '10 พฤษภาคม 2024',
        isEditabled: true,
      },
      {
        id: '862435EE-87E1-3211-BF6A-893751DA233A',
        projectCode: '66-00019',
        contractNo: '66-P1-0012',
        submisDate: '14/ก.พ./2567',
        modelType: '1',
        modelTypeLabel: 'ภ.ง.ด.3',
        taxMonth: 'พ.ย./2566',
        submisList: 'ยื่นเพิ่มเติม ครั้งที่ 002',
        ReferenceNo: 'P03XXXXXXXXXX',
        submisStatus: 'ยื่นแบบสำเร็จ (ออกใบเสร็จรับเงินแล้ว)',
        receiptDate: '10 พฤษภาคม 2024',
        submitName: 'นายโบวา เยล',
        phoneNumber: '0993845129',
        TransactionDate: '10 พฤษภาคม 2024',
        DateEdited: '10 พฤษภาคม 2024',
        isEditabled: true,
      },
      {
        id: '772435EE-87E1-3211-BF6A-893751DA233A',
        projectCode: '66-00019',
        contractNo: '66-P1-0012',
        submisDate: '18/ก.พ./2567',
        modelType: '2',
        modelTypeLabel: 'ภ.ง.ด.53',
        taxMonth: 'พ.ย./2566',
        submisList: 'ยื่นเพิ่มเติม ครั้งที่ 003',
        ReferenceNo: 'P53XXXXXXXXXX',
        submisStatus: 'ยื่นแบบสำเร็จ (ออกใบเสร็จรับเงินแล้ว)',
        receiptDate: '10 พฤษภาคม 2024',
        submitName: 'นายโบวา เยล',
        phoneNumber: '0993845129',
        TransactionDate: '10 พฤษภาคม 2024',
        DateEdited: '10 พฤษภาคม 2024',
        isEditabled: true,
      },
    ],
  },
}
